var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{ref:"canvas"},[(_vm.imageSource)?_c('img',{attrs:{"alt":_vm.imageAlt,"src":_vm.imageSource}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }